import { render } from "./EventList.vue?vue&type=template&id=3a64b6fc&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=3a64b6fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a64b6fc"

export default script